import { StoreDebugger } from "../TOOLS/StoreDebugger";

export class Store {
  constructor() {
    this.input = {
      startMouse: { x: 0, y: 0 },
      clickables: []
    };
    this.config = {
      isTouch: false,
      isSmall: false,
      officesSpawned: false
    };
    this.entities = {
      offices: [],
    };
    this.database = {
      databaseLoaded: false,
      users: null,
      actualUser: null,
      actualLocations: null,
      districts: null,
      offices: null
    };
    this.level = {
      levelName: 'BASE',
      selectedOffice: null,
      modal: null,
      selectedColleague: null,
      selectedCity: null,
      selectedDevice: null,
      cityCaller: null,
      cityuser: false,
      itDevices: [],
      otherDevices: [],
      modalOpen: false,
      detailsContainerVisible: false,
      formType: null,
      colleagueFilter: "FG",
      clickedOffice: null,
      formTarget: "modal",
      auth: false,
      move: false,
      spawnRadiusX: 0,
      spawnRadiusY: 0
    };
    this.events = new EventTarget();
    // DEBUGGER
    const storeDebugger = new StoreDebugger(this, {
      enabled: true,
      logChanges: true,
      level: {
          enabled: true,
          properties: [
              "cityCaller",
              "selectedCity",
              "selectedColleague",
              "cityuser",
              "cityColleagues"
          ]
      },
      database: {
          enabled: false,
          properties: null
      },
      input: {
          enabled: false,
          properties: null
      },
      config: {
          enabled: false,
          properties: null
      },
      entities: {
          enabled: false,
          properties: null
      }
    });
    return storeDebugger.getStore();
  }

}
